.dk{font-size:0.75rem;}